import React from 'react';

// REACT ROUTER IMPORTS
import Router from 'react-router/lib/Router';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import Link from 'react-router/lib/Link';
import withRouter from 'react-router/lib/withRouter';
import createHashHistory from 'history/lib/createHashHistory';
import useRouterHistory from 'react-router/lib/useRouterHistory';

//PAGES IMPORTS
import Base from './pages/Base.jsx';
import Index from './pages/Index.jsx';
import Login from './pages/LoginPage.jsx';
import Register from './pages/RegisterPage.jsx';
import Forgot from './pages/ForgotPwdPage.jsx';
import Pagina2 from './pages/Pagina2.jsx';

//RETENCIONES DE I.V.A
import RetIva from './pages/RetIva/RetIva.jsx';
import RetIvaReport from './pages/RetIva/RetIvaReport.jsx';
import RetIvaIndex from './pages/RetIva/RetIvaIndex.jsx';
import RetIvaCreate from './pages/RetIva/RetIvaCreate.jsx';

//RETENCIONES DE IMPUESTO SOBRE LA RENTA
import RetIslr from './pages/RetIslr/RetIslr.jsx';
import RetIslrIndex from './pages/RetIslr/RetIslrIndex.jsx';
import RetIslrCreate from './pages/RetIslr/RetIslrCreate.jsx';

//PROVEEDORES
import Proveedores from './pages/Proveedores/Proveedores.jsx';
import ProveedoresIndex from './pages/Proveedores/ProveedoresIndex.jsx';
import ProveedoresCreate from './pages/Proveedores/ProveedoresCreate.jsx';

//CORRELATIVOS, FIRMA, 404
import Correlativos from './pages/Correlativos.jsx';
import Firma from './pages/Firma.jsx';
import Expired from './pages/Expired.jsx';
import NotFound from './pages/404.jsx';

//USER 
import User from './pages/User/User.jsx';
import Perfil from './pages/User/Perfil.jsx';
import Suscripcion from './pages/User/Suscripcion.jsx';

import AuthActions from './reflux/AuthActions';

//DISABLE QUERY KEY FROM URLS
const History = useRouterHistory(createHashHistory)({
    queryKey: false
});

//DEFINE ROUTES
const Routes = () =>  (
    <Router history={History}>
        <Route path="/login" component={withRouter(Login)} onEnter={AuthActions.checkLogin} />
        <Route path="/register" component={withRouter(Register)} />
        <Route path="/expired" component={withRouter(Expired)}  />

        <Route path="/" component={withRouter(Base)} onEnter={AuthActions.checkLogin}>
            <IndexRoute component={Index} />
            <Route path="inicio" component={Index} />
            <Route path="nueva" component={Pagina2} />

            <Route path="/retiva" component={withRouter(RetIva)}>
                <IndexRoute component={withRouter(RetIvaIndex)} />
                <Route path="create" component={withRouter(RetIvaCreate)} />
                <Route path="edit/:id" component={withRouter(RetIvaCreate)} />
                <Route path="report" component={withRouter(RetIvaReport)} />
            </Route>

            <Route path="/retislr" component={RetIslr}>
                <IndexRoute component={withRouter(RetIslrIndex)} />
                <Route path="create" component={withRouter(RetIslrCreate)} />
                <Route path="edit/:id" component={withRouter(RetIslrCreate)} />
            </Route>

            <Route path="/proveedores" component={Proveedores}>
                <IndexRoute component={ProveedoresIndex} />
                <Route path="create" component={withRouter(ProveedoresCreate)} />
            </Route>

            <Route path="/user" component={User}>
                <IndexRoute component={withRouter(Perfil)} />
                <Route path="suscripcion" component={withRouter(Suscripcion)} />
            </Route>

            <Route path="correlativos" component={Correlativos} />
            <Route path="firma" component={Firma} />
            <Route path="*" component={NotFound} />
        </Route>
    </Router>
);

export default Routes;



/** WEBPACK FOOTER **
 ** ./app-react/Routes.jsx
 **/